<template>
    <div class="bg-grey full-height">
    
        <CRow class="m-0 justify-content-center align-items-center">
            <CCol sm="12" xs="6" class="text-right">
                <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
                    <img style="max-width: 40px; float: left; margin-right: 5px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
                    <span style="margin-top:20px">Trouble with loggin in</span>
                </h5>
    
            </CCol>
    
            <CCol sm="8" class="text-center mt-3" style="width: 90%; background-size: cover; margin: auto;">
                <div class="ustom-sub-title-app text-center mb-5 poppin-font">
                    Enter your email address and we will send a verification code to get back into your account
                </div>
                            <input v-model="email" class="custom-input-app" /> 
                            <div class="mt-4">
                        <div @click="Forgot()" class="button-border-blue text-white">
                            <label class="mt-2">Continue</label>
                        </div>
                        <br /> <br /> <br />
                    </div>
                </CCol>
    
        </CRow>

        <div v-if="isLanguagePopupVisible" class="popup-all backdrop-all" @click="closePopup">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/SuccessSubmit.png" />
                    <h3 class="custom-20px-500 text-center">Check Email </h3>
                    <label class="custom-12px-500">To reset your password, please refer to the email we just sent you.</label>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Confirm Now</CButton>
                    <label class="text-center custom-14px-500-blue">Skip</label>
                </div>
            </div>
        </div>

        <div v-if="isLanguagePopupVisible1" class="popup-all backdrop-all" @click="closePopup1">
            <div class="popup-all1">
                <!-- Popup content -->
                <div class="text-center">
                    <img style="max-width:100%" src="../assets/img/SuccessChek.png" />
                    <h3 class="custom-20px-500 text-center">Success</h3>
                    <label class="custom-12px-500">Your password is succesfully created</label>
                    <CButton type="button" class="button-border-blue text-white mt-4" block @click="GoToWishes()">Success</CButton>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default ({
    data() {
        return {
            isLanguagePopupVisible: false,
            isLanguagePopupVisible1: false,
            code: ["", "", "", ""],
            email: "",

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/RegisterHomepage");
        },

        GoToChangePassword() {
            // Close the popup and backdrop
            this.$router.push("/ChangePassword");
        },
        GoToVerify() {
            // Close the popup and backdrop
            this.$router.push("/VerifyCode?email=" + this.email);
        },
        submitVerification() {
            // const verificationCode = this.code.join(""); // Concatenate the digits
            // console.log("Verification Code:", verificationCode);

            // this.popupSuccess = true;

            this.isLanguagePopupVisible = true;
            

            // Add your logic to handle the verification code
        },

        closePopup() {
            this.isLanguagePopupVisible = false;
        },
        GoToWishes()
        {
            this.isLanguagePopupVisible1 = true;

        },
        closePopup1() {
            this.isLanguagePopupVisible = false;
            this.$router.push("UploadImage");
        },
        Forgot() {
      this.SubmittedForm = true;
      this.verify = true;
      const formData = new FormData();

      formData.append("userEmail", this.email);

      return this.$API
        .post(this.$ForgotPassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
            this.$router.push("/VerifyCode?email=" + this.email);

          } else {
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

          }
        });
    },

    }
})
</script>
